const crypto = require('crypto-js')

function readChunked(file, chunkCallback, endCallback) {
  var fileSize = file.size
  var chunkSize = 10 * 1024 * 1024 // 10 MB
  var offset = 0

  var reader = new FileReader()
  reader.onload = function () {
    if (reader.error) {
      endCallback(reader.error || {})
      return
    }
    offset += reader.result.length
    // callback for handling read chunk
    // TODO: handle errors
    chunkCallback(reader.result, offset, fileSize)
    if (offset >= fileSize) {
      endCallback(null)
      return
    }
    readNext()
  }

  reader.onerror = function (err) {
    endCallback(err || {})
  }

  function readNext() {
    var fileSlice = file.slice(offset, offset + chunkSize)
    reader.readAsBinaryString(fileSlice)
  }
  readNext()
}
export default function (blob, cbProgress) {
  return new Promise((resolve, reject) => {
    var sha256 = crypto.algo.SHA256.create()
    readChunked(
      blob,
      (chunk, offs, total) => {
        sha256.update(crypto.enc.Latin1.parse(chunk))
        if (cbProgress) {
          cbProgress(offs / total)
        }
      },
      (err) => {
        if (err) {
          reject(err)
        } else {
          // TODO: Handle errors
          var hash = sha256.finalize()
          var hashHex = hash.toString(crypto.enc.Hex)
          resolve(hashHex)
        }
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/functions/chunkedSHA256.js